/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAvailabilityBlockViewProps } from './availability-block';

const _renderImage = (imageUrl: string, imageAlt: string): JSX.Element => {
    return <img src={imageUrl} alt={imageAlt} />;
};

export default (props: IAvailabilityBlockViewProps) => {
    const { name, siteImageUrl, siteImageAlt, link } = props;

    const imageRender = _renderImage(siteImageUrl, siteImageAlt);

    let availability;

    if (link && siteImageUrl && name) {
        availability = (
            <div className='container'>
                <a href={link}>
                    <div className='row'>
                        <div className='col-6 text my-auto'>
                            <h3>{name}</h3>
                        </div>
                        <div className='col-6 img'>{imageRender}</div>
                    </div>
                </a>
            </div>
        );
    } else {
        availability = (
            <div></div>
        )
    }

    return (
        <div className="availability">
            {availability}
        </div>
    );
};
